import type { Activity } from '@user/features/Activity'
import { isAPIError, post } from '@user/store/services/crud'
import { urls } from '@user/features/Activity'
import { toast } from '@sales-center/components'
import { type Actions, createActivitiesBulkActionCreator } from '../state'

export async function createActivityBulkEffect(
  activity: Omit<Activity, 'id'>,
): Promise<Actions | undefined> {
  const response = await post(urls.upsertBulk, activity)

  if (response.ok) {
    return createActivitiesBulkActionCreator()
  }

  const result = await response.json()

  if (isAPIError(result.payload)) {
    toast.error(result.payload.Message)
  } else {
    toast.error('Failed to create Activity')
  }

  return undefined
}
